import React, { useEffect, useState } from "react";
import { TopNav } from "@/components/TopNav";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { formatVND } from "@/lib/money";
import { Wallet as WalletIcon, ArrowDownCircle, ArrowUpCircle, Gift, ShoppingBag, RefreshCw, Settings as Adjust } from "lucide-react";

const TYPE_META = {
  deposit: { label: "Nạp tiền", color: "text-emerald-300", icon: ArrowDownCircle, sign: 1 },
  withdraw: { label: "Rút tiền", color: "text-red-300", icon: ArrowUpCircle, sign: -1 },
  payment: { label: "Thanh toán", color: "text-orange-300", icon: ShoppingBag, sign: -1 },
  reward: { label: "Thưởng", color: "text-amber-300", icon: Gift, sign: 1 },
  refund: { label: "Hoàn tiền", color: "text-cyan-300", icon: RefreshCw, sign: 1 },
  adjustment: { label: "Điều chỉnh", color: "text-white/60", icon: Adjust, sign: 0 },
};

export default function Wallet() {
  const { user } = useAuth();
  const [txs, setTxs] = useState([]);
  useEffect(() => { api.get("/me/wallet/transactions").then(({ data }) => setTxs(data)); }, []);

  return (
    <div className="min-h-screen bg-[#05050a]">
      <TopNav />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-3 mb-6">
          <WalletIcon className="text-amber-300" />
          <h1 className="font-display font-bold text-3xl">Ví tiền</h1>
        </div>

        <div className="rounded-2xl bg-gradient-to-br from-amber-500/15 to-yellow-700/5 border border-amber-400/40 p-6 mb-6">
          <div className="text-xs uppercase tracking-widest text-amber-300 mb-1">Số dư hiện tại</div>
          <div className="font-display font-black text-5xl text-amber-300" data-testid="wallet-balance">{formatVND(user?.coin || 0)}</div>
          <div className="text-xs text-white/50 mt-2">Dùng để thanh toán giờ chơi, đồ uống, đổi quà, đăng ký giải đấu</div>
        </div>

        <h2 className="font-display font-semibold text-sm uppercase tracking-wider text-white/60 mb-3">Lịch sử giao dịch</h2>
        <div className="rounded-xl bg-[#0c0d14] border border-white/8 overflow-hidden" data-testid="wallet-tx-list">
          {txs.length === 0 ? (
            <div className="py-12 text-center text-white/40 text-sm">Chưa có giao dịch nào</div>
          ) : txs.map((t) => {
            const meta = TYPE_META[t.type] || TYPE_META.adjustment;
            const Icon = meta.icon;
            const positive = t.amount_vnd >= 0;
            return (
              <div key={t.id} className="flex items-center gap-3 p-4 border-b border-white/5" data-testid={`tx-${t.id}`}>
                <Icon size={18} className={meta.color} />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium">{meta.label}</div>
                  <div className="text-[11px] text-white/40 truncate">{t.description || "—"} · {new Date(t.created_at).toLocaleString("vi-VN")}</div>
                </div>
                <div className={`font-display font-bold ${positive ? "text-emerald-300" : "text-red-300"}`}>
                  {positive ? "+" : ""}{formatVND(t.amount_vnd)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
